import { Box, Heading } from '@chakra-ui/react';
import { PageLayout } from 'src/components/PageLayout';
import { ReferralTabs } from './components/ReferralTabs';
import { ReferralFaq } from './components/ReferralFaq';
import { ReferralReasons } from './components/ReferralReasons';
import { ReferralFooter } from './components/ReferralFooter';
import { useFirstBuyCouponQuery } from 'src/services/Promotions/queries';
import { ReferralAdvantages } from './components/ReferralAdvantages';
import { CenterContainer } from 'src/components/CenterContainer';

export const Referrals = () => {
  const {
    data: { code: firstBuyCoupon },
  } = useFirstBuyCouponQuery();

  return (
    <PageLayout className="overflow-x-hidden">
      <CenterContainer>
        <Heading
          fontSize={{ base: '2xl', lg: '5xl' }}
          mb={{ base: 5, lg: 6 }}
          fontWeight="400"
        >
          Indique lojistas e venda mais
        </Heading>
        <Box
          as="section"
          className="referrals-section__advantages"
          mb={{ base: 8, lg: 14 }}
        >
          <ReferralAdvantages />
        </Box>
        <Box as="section" className="referrals-section__tabs" mb={14}>
          <ReferralTabs />
        </Box>
        <section className="referrals-section__reasons">
          <ReferralReasons />
        </section>
        <section className="referrals-section__faq">
          <ReferralFaq firstBuyCoupon={firstBuyCoupon} />
        </section>
        <section className="referrals-section__footer">
          <ReferralFooter />
        </section>
      </CenterContainer>
    </PageLayout>
  );
};
